import React from 'react';
import { Translation } from 'react-i18next';
import Location from '../location/location.jsx';
import CustomTemplate from '../customtemplate/customtemplate.jsx';
import getTemplate from '../../utils/gettemplate';

const Locations = (props) => {
  // Element Variables
  let CustomMessage;
  let LocationsContainer;
  let Template;

  if (props.searchable === false) {
    if (props.disableGeolocation) {
      Template = getTemplate(props, 'locations-search-required');
      if (Template) {
        CustomMessage = <CustomTemplate template={Template} />;
      }
      LocationsContainer = <div className="sb-locations-message sb-no-user-location" role="listitem">
        {CustomMessage || (<Translation>{(t) => <span>{t('Please search for a location above')}</span>}</Translation>)}
      </div>;
    } else {
      Template = getTemplate(props, 'locations-nolocation-search-required');
      if (Template) {
        CustomMessage = <CustomTemplate template={Template} />;
      }
      LocationsContainer = <div className="sb-locations-message sb-no-user-location" role="listitem">
        {CustomMessage || (<Translation>{(t) => <span>{t('We cannot find your current location. Please search for a location above')}</span>}</Translation>)}
      </div>;
    }
  } else if (props.error) {
    Template = getTemplate(props, 'invalid-request');
    if (Template) {
      CustomMessage = <CustomTemplate template={Template} />;
    }
    LocationsContainer = <div className="invalid-request" role="listitem">
      {CustomMessage || (<Translation>{(t) => <span>{t('Invalid Request')}</span>}</Translation>)}
    </div>;
  } else if (props.locations.length === 0 && props.loadingStatus === true) {
    /* loading message */
    Template = getTemplate(props, 'locations-loading-message');
    if (Template) {
      CustomMessage = <CustomTemplate template={Template} />;
    }
    LocationsContainer = <div className="sb-locations-loading" role="listitem">
      {CustomMessage || (<Translation>{(t) => <span>{t('Loading')}...</span> }</Translation>)}
    </div>;
  } else if (props.locations.length > 0) {
    /* list of locations */
    LocationsContainer = <div role="listitem"></div>;
    // Full locations list generates hundreds of DOM elements which creates laggy behaviors
    // const truncatedLocations = props.locations.length < 40 ? props.locations : props.locations.slice(0, 39);
    LocationsContainer = props.locations.map((location) => {
      return <Location
        customTemplates={props.customTemplates}
        key={location.id}
        data={location}
        selectedLocationId={props.selectedLocationId}
        setCenterPosition={props.setCenterPosition}
        setSelectedLocationId={props.setSelectedLocationId}
        toggleDisplayInfoWindow={props.toggleDisplayInfoWindow}
      />;
    });
  } else if (props.activeFilters) {
    /* no locations found due to filters */
    Template = getTemplate(props, 'locations-not-found-filters');
    if (Template) {
      CustomMessage = <CustomTemplate template={Template} />;
    }
    LocationsContainer = <div className="sb-locations-message sb-locations-notfound" role="listitem">
      {CustomMessage || (<Translation>{(t) => <span>{t('No locations found with the selected filters')}</span>}</Translation>)}
    </div>;
  } else if (!props.loadingStatus) {
    /* no locations found */
    Template = getTemplate(props, 'locations-not-found');
    if (Template) {
      CustomMessage = <CustomTemplate template={Template} />;
    }
    LocationsContainer = <div className="sb-locations-message sb-locations-notfound" role="listitem">
      {CustomMessage || (<span><Translation>{(t) => t('No locations found')}</Translation></span>)}
    </div>;
  } else {
    LocationsContainer = <div role="listitem"></div>;
  }
  return (LocationsContainer);
};

export default Locations;
